import * as ActionTypes from './ActionTypes'

/**
 * Sets the pusher cluster.
 * @param {String} cluster A pusher cluster.
 */
export function setCluster(cluster) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNPUSHER_SET_CLUSTER,
      cluster: cluster,
    })
  }
}

/**
 * Sets the pusher key.
 * @param {boolean} key A pusher key.
 */
export function setKey(key) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNPUSHER_SET_KEY,
      key: key,
    })
  }
}
